const accentStyles = {
  blue: {
    pill: "text-blue-400 bg-blue-900/40",
    border: "border-l-blue-500",
  },
  green: {
    pill: "text-emerald-400 bg-emerald-900/40",
    border: "border-l-emerald-500",
  },
  emerald: {
    pill: "text-emerald-400 bg-emerald-900/40",
    border: "border-l-emerald-500",
  },
  purple: {
    pill: "text-purple-400 bg-purple-900/40",
    border: "border-l-purple-500",
  },
  amber: {
    pill: "text-amber-400 bg-amber-900/40",
    border: "border-l-amber-500",
  },
  rose: {
    pill: "text-rose-400 bg-rose-900/40",
    border: "border-l-rose-500",
  },
  cyan: {
    pill: "text-cyan-400 bg-cyan-900/40",
    border: "border-l-cyan-500",
  },
  red: {
    pill: "text-rose-400 bg-rose-900/40",
    border: "border-l-rose-500",
  },
};

function CornerBrackets() {
  const corners = [
    { pos: "top-0 left-0", varName: "--bracket-tl" },
    { pos: "top-0 right-0", varName: "--bracket-tr" },
    { pos: "bottom-0 left-0", varName: "--bracket-bl" },
    { pos: "bottom-0 right-0", varName: "--bracket-br" },
  ];

  return corners.map(({ pos, varName }, i) => {
    const isTop = pos.includes("top");
    const isLeft = pos.includes("left");
    return (
      <span
        key={i}
        className={`absolute ${pos} pointer-events-none`}
        style={{
          width: "14px",
          height: "14px",
          borderTop: isTop ? `1px solid var(${varName})` : "none",
          borderBottom: !isTop ? `1px solid var(${varName})` : "none",
          borderLeft: isLeft ? `1px solid var(${varName})` : "none",
          borderRight: !isLeft ? `1px solid var(${varName})` : "none",
        }}
      />
    );
  });
}

import { Sparkles } from "lucide-react";
import ObservationCornerBadge from "@ui/ObservationCornerBadge";

export default function InfoBentoCard({
  title,
  subtitle,
  icon,
  accent = "blue",
  cornerGlow = false,
  frostedGradient = false,
  className = "",
  onClick,
  aiObservations,
  aiContainerLabel,
  children,
}) {
  const colors = accentStyles[accent] || accentStyles.blue;

  const baseClasses = `relative border-l-2 ${colors.border} p-4 transition-colors duration-300`;

  const bgStyle = frostedGradient
    ? {
        background: 'var(--bg-card-frosted)',
        border: '1px solid var(--border-card-frosted)',
      }
    : {
        border: '1px solid var(--border-card-base)',
      };

  const hasObservations = aiObservations && aiObservations.length > 0;
  const hasDiscuss = !!onClick;

  return (
    <div
      className={`${baseClasses} ${className}`}
      style={{ ...bgStyle, overflow: cornerGlow || hasObservations ? "visible" : "hidden" }}
    >
      {cornerGlow && (
        <div
          className="absolute pointer-events-none"
          style={{
            top: "-30px",
            left: "-30px",
            right: "-30px",
            bottom: "-30px",
            background: "radial-gradient(ellipse at 30% 20%, var(--glow-color), transparent 70%)",
            zIndex: -1,
          }}
        />
      )}

      {cornerGlow && <CornerBrackets />}

      {hasObservations && (
        <ObservationCornerBadge
          observations={aiObservations}
          containerLabel={aiContainerLabel || title || "this item"}
        />
      )}

      {(title || icon) && (
        <div className="flex items-center gap-2.5 mb-3">
          {icon && (
            <div className={`p-1.5 rounded-md ${colors.pill}`}>
              {icon}
            </div>
          )}
          <div className="flex-1 min-w-0">
            {title && (
              <h3 className="text-sm font-bold uppercase tracking-wider text-gray-200">
                {title}
              </h3>
            )}
            {subtitle && (
              <p className="text-xs text-gray-400">{subtitle}</p>
            )}
          </div>
        </div>
      )}

      {/* Discuss-with-AI button — always anchored bottom-right so it never
          steals horizontal room from the card's title/content. Top-right is
          taken by ObservationCornerBadge when observations exist. */}
      {hasDiscuss && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onClick(e);
          }}
          className="absolute bottom-2 right-2 flex items-center justify-center p-1.5 rounded-md text-white transition-opacity hover:opacity-90 z-10 shadow-md"
          style={{ background: "var(--ai-icon)" }}
          title="Discuss with AI"
          aria-label="Discuss with AI"
        >
          <Sparkles className="w-3.5 h-3.5" />
        </button>
      )}

      {children}
    </div>
  );
}
